import { injectable } from 'inversify'
import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';
import { ok, err } from '@xlearn/common'
import store from '@/store';
import { Question } from './question'
import { reportNonFatalError } from '@/app/error-handling';

export type LoadingPhase = 'none' | 'loading' | 'loaded';

export const QuestionStoreModuleSymbol = Symbol.for('QuestionStoreModule');

export type FindQuestionsError = 'questions-not-loaded' | 'not-found'

@injectable()
@Module({
  namespaced: true,
  name: 'question',
  store,
  dynamic: true
})
export class QuestionStoreModule extends VuexModule {

  private phase: LoadingPhase = 'none'  
  private loadedQuestions: Question[] = []

  @Mutation
  public startLoading() {
    this.phase = 'loading';
    this.loadedQuestions = [];
  }

  @Mutation
  public finishLoading(questions: Question[]) {
    this.loadedQuestions = questions;
    this.phase = 'loaded';
  }

  get questions() {
    return this.loadedQuestions
  }

  get findQuestions() {
    const self = this
    return function(ids: string[]) {

      if (self.loadingPhase !== 'loaded') {
        return err('not-loaded' as FindQuestionsError)
      }

      const found = ids.map(id => self.questions.find(q => q.id === id))
      if (found.findIndex(x => x === undefined) >= 0) {
        reportNonFatalError(`Question not found; phase: ${self.phase}`, ids, found, JSON.stringify(self.questions))
        return err('question-not-found' as FindQuestionsError)
      }

      return ok(found.map(x => x!))
    }
  }

  get loadingPhase() {
    return this.phase
  }
}

export default getModule(QuestionStoreModule);
